export default {
  player: {
    personHeight: 1.8,
    speedMultiplier: 3,
  },
  gallery: {
    scale: 1.75,
  },
};
